import { useSelector } from "react-redux";
import type { AppState } from "@ch/redux-store/root-reducer";

const useKemConsentDetails = () => {
  const currentUser = useSelector((s: AppState) => s.user.currentUser);

  const kemConsentFormId = currentUser?.kemConsentFormId;
  const kemGuardianFormCurrentStatus =
    currentUser?.kemGuardianFormCurrentStatus;

  const isKemConsentFormApproved = kemGuardianFormCurrentStatus === "approved";
  const isKemConsentFormRejected = kemGuardianFormCurrentStatus === "rejected";
  const isKemConsentFormPendingExplicit =
    kemGuardianFormCurrentStatus === "pending";

  // prefer explicit pending; fall back to manual checking
  const isKemConsentFormPending =
    isKemConsentFormPendingExplicit ||
    (!isKemConsentFormApproved &&
      (isKemConsentFormRejected || !!kemConsentFormId));

  return {
    kemConsentFormId,
    kemGuardianFormCurrentStatus,
    isKemConsentFormApproved,
    isKemConsentFormRejected,
    isKemConsentFormPendingExplicit,
    isKemConsentFormPending,
  };
};

export default useKemConsentDetails;
